export default {
  token(state) {
    return state.token
  },
  userInfo(state) {
    return state.userInfo
  },
  customcmd(state) {
    return state.customcmd
  },
  companyId(state) {
    return state.companyId
  },
  showHistory(state) {
    return state.showHistory
  },
  firstEnter(state) {
    return state.firstEnter
  },
  historyList(state) {
    return state.historyList
  },
  appScroll(state) {
    return state.appScroll
  },
  isMobile(state) {
    return state.isMobile
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js